import request from '@/utils/request'

export const getYearClosings = params => request.get('/accounting/year-closings', { params })

export const previewYearClosing = params => request.get('/accounting/year-closings/preview', { params })

export const createYearClosing = data => request.post('/accounting/year-closings', data)

export const getYearClosing = id => request.get(`/accounting/year-closings/${id}`)

export const reverseYearClosing = (id, data) => request.post(`/accounting/year-closings/${id}/reverse`, data)
